import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number, currency: string = "CAD"): string {
  const code = currency.toUpperCase() || "CAD";
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: code,
    minimumFractionDigits: 0,
    maximumFractionDigits: code === "JPY" ? 0 : 2,
  }).format(value);
}
